import {
  getIsEmail,
  getIsPhone,
} from 'features/v2a/sender/helpers/Sender.helpers';
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { StyleSheet, View } from 'react-native';
import AmplitudeMask from 'shared/components/AmplitudeMask/AmplitudeMask';
import Button from 'shared/components/vxl/Button/Button';
import RadioButtonGroup from 'shared/components/vxl/selection/RadioButton/RadioButtonGroup';
import TitleMdText from 'shared/components/vxl/typography/primary/title/TitleMdText';
import { usePressableAnalytics } from 'shared/hooks/analytics/usePressableAnalytics';
import { useViewDidFocusScreenAnalyticsEvent } from 'shared/hooks/analytics/useViewDidFocusAnalytics';
import theme from 'shared/styles/theme';
import { formatPhoneNumber } from 'shared/utils/string/phone';

interface MultipleContactsProps {
  contacts: string[];
  setChosenContact: (contact: string) => void;
}

const contactOptions = (contacts: string[]) =>
  contacts.map((contact) => ({
    labelText: getIsPhone(contact)
      ? formatPhoneNumber(contact, false)
      : contact,
    value: contact,
  }));

const MultipleContacts = ({
  contacts,
  setChosenContact,
}: MultipleContactsProps) => {
  const [shouldDisableSelectButton, setShouldDisableSelectButton] =
    useState(true);
  const [contact, setContact] = useState<string>('');
  const { t: translatedText } = useTranslation('moveMoney', {
    keyPrefix: 'sender',
  });

  const contactSelected = usePressableAnalytics({
    analyticsId: 'v2aContactSelected',
    customAttributes: {
      contact_type: getIsEmail(contact) ? 'email' : 'phone',
    },
  });

  useEffect(() => {
    if (contact) {
      contactSelected();
    }
  }, [contact, contactSelected]);

  const handleSelectedContact = (item: string) => {
    setContact(item);
    setShouldDisableSelectButton(false);
  };

  useViewDidFocusScreenAnalyticsEvent({ key: 'V2aMultipleContactsForm' });

  return (
    <View style={styles.multipleContactsSection}>
      <TitleMdText>{translatedText('multipleContacts.title')}</TitleMdText>
      <AmplitudeMask>
        <RadioButtonGroup
          onPress={handleSelectedContact}
          options={contactOptions(contacts)}
        />
      </AmplitudeMask>

      <Button
        label={translatedText('multipleContacts.selectButton')}
        isDisabled={shouldDisableSelectButton}
        onPress={() => setChosenContact(contact)}
        size="LARGE"
        analyticsId="v2aContactSubmitted"
        customAttributes={{
          contact_type: getIsEmail(contact) ? 'email' : 'phone',
        }}
        type="PRIMARY"
      />
    </View>
  );
};

const styles = StyleSheet.create({
  multipleContactsSection: {
    gap: theme.spacing.m,
    paddingBottom: theme.spacing.m,
    paddingHorizontal: theme.spacing.m,
  },
});

export default MultipleContacts;
